import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.00004 10.6667V8.00001M8.00004 5.33334H8.00671M14.6667 8.00001C14.6667 11.6819 11.6819 14.6667 8.00004 14.6667C4.31814 14.6667 1.33337 11.6819 1.33337 8.00001C1.33337 4.31811 4.31814 1.33334 8.00004 1.33334C11.6819 1.33334 14.6667 4.31811 14.6667 8.00001Z",
		stroke: "#4C5AFF",
		strokeWidth: 1.4,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgInfoIcon;
